// extracted by mini-css-extract-plugin
module.exports = {"pages":"Pages_pages__1Kiy4"};